import createHashHistory from 'history/lib/createHashHistory'
export default createHashHistory()



// WEBPACK FOOTER //
// ./client/config/history.js